import { NgModule } from '@angular/core';
import { SavedCartEventBuilder } from './saved-cart-event.builder';

@NgModule({})
export class SavedCartEventsModule {
  constructor(_savedCartEventBuilder: SavedCartEventBuilder) {}
}
